module.exports = __webpack_public_path__ + "img/img4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img4.jpg
// module id = 1297
// module chunks = 0